module.exports = __webpack_public_path__ + "img/blackLogo.e374686b.webp";